export default "__VITE_ASSET__Cw3Z6uV___"